import { IS_CLIENT } from '../../constants';
import { getLocale } from '../../locale';
import NextLocaleHelper from '../NextLocaleHelper';
import { getStoredAemLabels, getStoredHybrisLabels } from './getLabelsByStorageKey';
// Cache labels in local variable to reduce number of calls to sessionStorage / localStorage
let labels;
const getLabelsFromStorage = (locale) => {
    const currentLocale = (IS_CLIENT ? locale : NextLocaleHelper.locale) || getLocale();
    if (labels === null || labels === void 0 ? void 0 : labels[currentLocale]) {
        return labels[currentLocale];
    }
    const hybrisLabels = getStoredHybrisLabels(currentLocale);
    const aemLabels = getStoredAemLabels(currentLocale);
    // Missing LSL labels
    if (!!hybrisLabels || !!aemLabels) {
        if (!labels) {
            labels = {};
        }
        labels[currentLocale] = Object.assign(Object.assign({}, (hybrisLabels || {})), (aemLabels || {}));
        return labels[currentLocale];
    }
    return undefined;
};
// Should be used only in tests or some internal purposes!
export const clearLabelsCache = () => {
    labels = undefined;
};
export default getLabelsFromStorage;
//# sourceMappingURL=getLabelsFromStorage.js.map